import { render, staticRenderFns } from "./PacketizationDiagramRenderer.vue?vue&type=template&id=63c01cba&"
import script from "./PacketizationDiagramRenderer.vue?vue&type=script&lang=ts&"
export * from "./PacketizationDiagramRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports